/* istanbul ignore next */
import { NotificationContainer, NotificationManager } from 'react-notifications';
/* istanbul ignore next */
import 'react-notifications/lib/notifications.css';

/* istanbul ignore next */
export default class VerboseUI extends NotificationContainer {};

/* istanbul ignore next */
let activeGrowls = 0;

/* istanbul ignore next */
setTimeout(() => {
  NotificationManager.warning('Verbose is active!');
}, 1000);

/* istanbul ignore next */
export function growlFromNativeCalls(payload) {
  const nativeValues = getNativeValues(payload);
  const message = `From Method: ${ payload.methodName }
     ${ nativeValues.length > 0 ? `Values: ${ nativeValues.join('\n') }` : '' }`;
  console.info(message); // eslint-disable-line no-console
  NotificationManager.info(message);
}

/* istanbul ignore next */
export function growlToNativeCalls(payload) {
  const nativeValues = getNativeValues(payload);
  const message = `To Method: ${ payload.methodName }
      ${ nativeValues.length > 0 ? `Values: ${ nativeValues.join('\n') }` : '' }`;
  console.info(message); // eslint-disable-line no-console
  NotificationManager.info(message);
}

/* istanbul ignore next */
export function getNativeValues(payload) {
  checkGrowls();
  return Object.keys(payload)
    .filter(key => key !== 'methodName')
    .sort()
    .map(key => `${ key }: ${ JSON.stringify(payload[key], null, 2) }`);
}

/* istanbul ignore next */
function checkGrowls() {
  activeGrowls = document.querySelectorAll('.notification').length;
  if (activeGrowls < 11) return;
  const egg = document.createElement('pre');
  const eggStyle = egg.style;
  eggStyle.position = 'fixed';
  eggStyle.left = 0;
  eggStyle.top = 0;
  eggStyle.width = '100%';
  eggStyle.height = '100%';
  eggStyle.backgroundColor = 'pink';
  eggStyle.color = 'black';
  eggStyle.zIndex = 999999;
  egg.innerHTML = `                  s@@G%7777%e@@^                                       
                 B77777777777777777777@                                   
               C77777777777777777777777777@73@                            
             @777777777777777777777777777777@t77G                         
            77777777777777777777777@777777777@t7@777                      
           77777777777777777777777777777777777Qttt77t                     
          @7777777777777777777777777777777777737tttt@7@                   
          777777777777777777777777777777%7s77%7t777t73t7                  
         @777777777777777777777777777777777777t777t777t77                 
         777777777777777777777777%7777777777@77t7@t77tt#7@                
         777777777777777777777777Q777777777%7tt7ttt7t7t7@t                
         %7777777777777777777777777777777@ttQt7t7ttt7777t#                
         K%77777777s777777777777777777776t7t7Ot7777tG7tt7R                
         @      %7777@R%77777%K@@^777777@t77t7@777Stt@t7@                 
          @@# @77777C@            777777@tt77B77@77Rtt7@                  
         @77O77777777@     #@@@@@@777777@t777@7@t77S7t(                   
         R777777777777777777777777777777@7t77B77777R(                     
       @7777777777777777777K@@@%77777777@7777%777@                        
      777777e77777777777777777777777777777t7777                           
    @77777@77777@7777777777777777777777777777C                            
   C77777777S@777777777777777777777777777777B                             
  K77777R/777777777777777777777777777777777@                              
 t7777@  @7777777777777777777777777777777R                                
  @@    e7777777777777777777777C#RC77777                                  
      K7777777777777777777@      @77777@                                  
      777777777777777@t  s   7777777777@                                  
        @677777Q@    @B@777777777777777Ot                                 
               ~   @C7777777777777777777@OO@                              
                        @77777777777777# QOO@                             
                          777777777777e  %OOOOO@                          
                         /@77777777776    OOO@OOOO@                       
                         OO @%7777@       SOOOOOOOOO#                     
                        %OO   @@@         ROOOOOOOOOOOG                   
                        OO@  @@@@@        #OOO@OOOOOOOO#                  
                        OO@  @@@@@@     @ SOOOOOOOOOOOOOO                 
                       @OO@@ R@@@@(   G   OOOOOOOOOOOOOOOO                
                       OOO@   @@@@        OOOOO@OOOOOOOOOOO               
                      6OOO@    @@@       /OOOOO@OOOOOOOOOOO@              
                       OOO@   e@@@       @OOOOOOOOOOOOOOOOOO@             
                       OOOQ   @@@@       OOeOOOOOOOOOOOOOOOOO             
                      QOOOO  @@@@@@     @O@OOOOOOOOOOOOOOOOOOO            
                      #OOOO /@@@@@@     OO@OOOOOOOOOOOOOOOOOOO@           
                      O#OOOt@@@@@@@t   7OOOO@OOOOOOOOOOOOOOOOOO           
                      GOOOO@@@@@@@@@   #OOOOOOOOOO@OOOOOOOOOOOOO          
                      BOOOOe@@@@@@@@   OOOOOOOOOOOO@OOOOOOOOOOOO@         
                     @@OOOOO@@@@@@@@@ @OOOOOBOOOOOOO@OOOOOOOOOOOO/        
                     KOOOOOO@@@@@@@@@ OOOOO#OOOOOOOOOGOOOOOOOOOOOO        
                     OOROOOOR@@@@@@@@@OOOOOOOOOOOOOOOOOOOOOOOOOOOO@       
                    @OOQOOOOO@@@@@@@@GOOOO#OOOOOOOOOOO@OOOOOOOOOOOO       
                    OOOOSOOOO@@@@@@@@OOOO@OOOOOOOOOOOOOOOOOOOOOOOOOG      
                   QOOOOOOOOOS@@@@@@eOOO#OOOOOOOOOOOOOO@OOOOOOOOOOOO@     
                   KOOOOO#OOOO@@@@@@OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOC    
                   OOOOOOOROOO@@@@@OOOOROOOOOOOOOOOOOOOO@OOOOOOOOOOOOO`;
  document.body.appendChild(egg);
  setTimeout(() => {
    document.body.removeChild(egg);
  }, 1000);
}


// WEBPACK FOOTER //
// ./src/verbose-ui.js